import { Injectable } from '@angular/core';
import { DatabaseService } from './database.service';
import { UserChangeService } from './user-change.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DocumentData, DocumentSnapshot } from 'firebase/firestore';
import { OutletsList } from '../models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ListsService {
  outletsDoc$:BehaviorSubject<OutletsList> = new BehaviorSubject(null)
  private _outletsDoc:OutletsList = null
  get outletsDoc(){
    return this._outletsDoc
  }
  private outletsDocSubscription:Subscription
  constructor(
    private database: DatabaseService,
    private userChangeService:UserChangeService,
  ) { 
    this.userChangeService.user$.subscribe((user) => {
      if(!user) return;
      //this.listenToOutletsDoc(true);
    });
  }

  listenToOutletsDoc(force=false){
    if(force && this.outletsDocSubscription){
      this.outletsDocSubscription.unsubscribe();
    }
    if(!this.outletsDocSubscription||this.outletsDocSubscription.closed){
      this.database.listenToOutletsList(this.outletsDoc$)
      this.outletsDocSubscription = this.outletsDoc$.subscribe((outletsDoc)=>{
        this._outletsDoc = outletsDoc
        console.log(outletsDoc);
      })
    }else{
      console.log('Already listening. subscribe to the active subject instead');
    }
  }

}
